import { render, staticRenderFns } from "./product4.vue?vue&type=template&id=e5d68aec&scoped=true&"
import script from "./product4.vue?vue&type=script&lang=js&"
export * from "./product4.vue?vue&type=script&lang=js&"
import style0 from "./product4.vue?vue&type=style&index=0&id=e5d68aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d68aec",
  null
  
)

export default component.exports